import styled from 'styled-components';
import styles from './styles.module.css';
export const Checkbox = ({
	label,
	name,
	isChecked,
	value,
	error,
	disabled,
	handleChange
}: CheckboxProps): JSX.Element => {
	return (
		<>
			<Container>
				<StyledCheckbox
					className={styles.checkbox}
					id={name}
					type="checkbox"
					name={name}
					checked={isChecked}
					value={value}
					disabled={disabled}
					onChange={handleChange}
				/>
				<Label htmlFor={name}> {label}</Label>
			</Container>
			{error && <ErrorDiv>{error}</ErrorDiv>}
		</>
	);
};

export default Checkbox;

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string | React.ReactElement;
	name?: any;
	handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	isChecked: boolean;
	disabled?: boolean;
	value?: any;
	error?: string | null;
}

const Label = styled.label`
	font-size: 14px;
	color: #575757;
	font-weight: bold;
	cursor: pointer;
	margin-top: 0.5rem;
	line-height: 125%;
`;

const StyledCheckbox = styled.input`
	-webkit-appearance: none;
	appearance: none;
	width: 24px;
	height: 24px;
	min-height: 24px;
	min-width: 24px;
	border-radius: 4px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);
	outline: none;
	border: 2px solid #f47920;
	cursor: pointer;

	&:checked {
		position: relative;
		&:before {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 100%;
			height: 100%;
		}
		&:after {
			content: '';
			background-position: center;
			position: absolute;
			top: 50%;
			// percentage adjustment due to element distortion
			left: 53%;
			transform: translate(-50%, -50%);
			width: 100%;
			height: 100%;
			font-size: 16px;
			color: #f47920;
			transition: all 0.2s;
		}
	}
`;

const Container = styled.label`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 12px;
	margin-bottom: 12px;
`;

const ErrorDiv = styled.div`
	margin-top: 8px;
	color: #db2828 !important;
	font-weight: bold;
	font-size: 90%;
	line-height: 125%;
	margin-bottom: 0;
`;
